import React from 'react'
import Images from '../assets/images/Images';
import { getRedirectEnv } from '../services/Utils';

const OtherOptions = ({show, setShow}) => {
    return (
        show &&
        <>
            <div onClick={() => setShow(false)} className="modal fade show" style={{ display: "block" }} id="OtherOptions" tabIndex="-1" aria-labelledby="OtherOptionsLabel">
                <div onClick={(e) => e.stopPropagation()} className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content quick-mc">
                        <div className="quick-modal-header" style={{ background: "#046ab0", color: "white", position: "relative" }}>
                            {/* <%-- Desktop --%> */}
                            <div id="header-desktop" style={{ width: "100%" }}>
                                {/* <%-- Infinity Autopay --%> */}
                                <div id="infinity" className="col-sm-5 col-md-4 d-flex" style={{ justifyContent: "center" }}>
                                    <img src={Images.portalOne.nouns.infinity} width="80" height="38" style={{ paddingRight: "10px" }} />
                                    <span style={{ fontSize: "22px", marginTop: "3px" }}>Autopay</span>
                                </div>
                                {/* <%-- Avoid convenience --%> */}
                                <div id="convenience" className="col-sm-7 col-md-8">
                                    <div className="pb-2">
                                        Avoid convenience fees. Never miss a payment.
                                    </div>
                                    <a href={`https://${getRedirectEnv()}`} type="button" className="btn btn-secondary btn-sm" style={{ padding: "5px 35px", background: "#ff8000", borderRadius: "7px", color: "white" }}>
                                        ENROLL
                                    </a>
                                </div>
                            </div>
                            {/* <%-- Mobile --%> */}
                            <div id="header-mobile" style={{ marginTop: "-15px", width: "100%" }}>
                                {/* <%-- Infinity Autopay --%> */}
                                <div className="col-sm-5 pb-2 d-flex justify-content-center">
                                    <img src={Images.portalOne.nouns.infinity} width="80" height="38" style={{ paddingRight: "10px" }} />
                                    <span style={{ fontSize: "22px", marginTop: "3px" }}>Autopay</span>
                                </div>
                                {/* <%-- Avoid convenience --%> */}
                                <div className="col-sm-7 text-center" style={{display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start"}}>
                                    <div className="pb-2 mobile-convenience" style={{textAlign: "left", textWrap: "nowrap", whiteSpace: "nowrap"}}>
                                        Avoid convenience fees. <br />
                                        Never miss a payment.
                                    </div>
                                    <a href={`https://${getRedirectEnv()}`} type="button" className="btn btn-secondary btn-sm" style={{ padding: "5px 35px", background: "#ff8000", borderRadius: "7px", color: "white" }}>
                                        ENROLL
                                    </a>
                                </div>
                            </div>
                            {/* <%-- Close button --%> */}
                            <button onClick={() => setShow(false)} type="button" className="close otheroptions-close" data-dismiss="modal" aria-label="Close" style={{ float: "right", backgroundColor: "transparent", border: "0", position: "absolute", padding: "0px", right: "20px", zIndex: "10", paddingTop: "20px", width: "25px", height: "25px" }}>
                                <span aria-hidden="true" style={{ display: "block", fontSize: "25px", lineHeight: "25px", color: "black", textShadow: "0 1px 0 #fff" }}>&times;</span>
                            </button>
                        </div>

                        <div className="quick-modal-body" style={{ color: "#046ab0" }}>
                            <div className="container-fluid">
                                {/* <%-- Additional Payment Options --%> */}
                                <div className="row">
                                    <div className="col-md-12 text-center pb-3" style={{ color: "black", fontSize: "20px" }}>
                                        Additional Payment Options
                                    </div>
                                </div>
                                {/* <%-- Desktop --%> */}
                                {/* <%-- First row --%> */}
                                <div className="row px-4 pb-4">
                                    {/* <%-- Pay By Phone Automated --%> */}
                                    <div className="col-6 payment-option" style={{ display: "flex" }}>
                                        <div className="col-2 pl-0">
                                            <img src={Images.portalOne.nouns.phonePayment} width="40" height="50" />
                                        </div>
                                        <div className="col-10 pl-1" style={{ fontSize: "14px" }}>
                                            <div className="payment-option-title pb-2">Pay By Phone Automated</div>
                                            <div className="payment-option-parag pb-2">
                                                Use the automated interactive
                                                phone system 24/7 with your
                                                checking, savings, credit or
                                                debit card. A convenience fee
                                                of $14.95 applies.*
                                            </div>
                                            <div className="payment-option-parag pb-2">
                                                833-481-2486
                                            </div>
                                        </div>
                                    </div>
                                    {/* <%-- Text-to-Pay --%> */}
                                    <div className="col-6 payment-option" style={{ display: "flex" }}>
                                        <div className="col-2 pl-0">
                                            <img src={Images.portalOne.nouns.mobile} width="35" height="50" />
                                        </div>
                                        <div className="col-10 pl-1" style={{ fontSize: "14px" }}>
                                            <div className="payment-option-title pb-2">Text-to-Pay</div>
                                            <div className="payment-option-parag pb-2">
                                                Enroll in Text-to-Pay by
                                                logging into <a href={`https://${getRedirectEnv()}`}>My Account</a>.
                                                Once enrolled, you can pay
                                                by text using your checking,
                                                savings, credit or debit card.
                                                A convenience fee of $5.99
                                                applies.*
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="payment-spacer" className="px-4 pb-3">
                                    <div className="line px-2"></div>
                                    <div style={{ height: "1px", width: "5%" }}></div>
                                    <div className="line px-2"></div>
                                </div>
                                {/* <%-- Second row --%> */}
                                <div className="row px-4">
                                    {/* <%-- Pay By Phone Live Agent --%> */}
                                    <div className="col-6 payment-option" style={{ display: "flex" }}>
                                        <div className="col-2 pl-0">
                                            <img src={Images.portalOne.nouns.telemarketing} width="40" height="36" />
                                        </div>
                                        <div className="col-10 pl-1" style={{ fontSize: "14px" }}>
                                            <div className="payment-option-title pb-2">Pay By Phone Live Agent</div>
                                            <div className="payment-option-parag pb-2">
                                                Contact a live agent with your checking, savings, credit or debit card.
                                                A convenience fee of $17.95 applies.*
                                            </div>
                                            <div className="payment-option-parag pb-2">
                                                800-535-2873
                                            </div>
                                            <div className="payment-option-parag pb-2">
                                                Mon-Fri 8:00 am – 7:00 pm <br />
                                                Sat 9:30 am – 4:00 pm
                                            </div>
                                        </div>
                                    </div>
                                    {/* <%-- Pay By Mail --%> */}
                                    <div className="col-6 payment-option" style={{ display: "flex" }}>
                                        <div className="col-2 pl-0">
                                            <img src={Images.portalOne.nouns.envelope} width="40" height="40" />
                                        </div>
                                        <div className="col-10 pl-1" style={{ fontSize: "14px" }}>
                                            <div className="payment-option-title pb-2">Pay By Mail</div>
                                            <div className="payment-option-parag pb-2">
                                                Send a check or money order
                                                and be sure to include your
                                                Policy Number.
                                            </div>
                                            <div className="payment-option-parag pb-2">
                                                CURE <br />
                                                PO Box 48285 <br />
                                                Newark, NJ 07101-8485
                                            </div>
                                            <div className="payment-option-parag pb-2">
                                                Note: We recommend 5-7
                                                business days for mail and
                                                processing time.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <%-- Mobile --%> */}
                                {/* <%-- Text-to-Pay --%> */}
                                <div className="payment-option px-1 pb-2">
                                    <div className="col-3 pl-0 pt-1">
                                        <img src={Images.portalOne.nouns.mobile} width="54" height="80" />
                                    </div>
                                    <div className="col-9 pl-1" style={{ fontSize: "14px" }}>
                                        <div className="payment-option-title pb-2">Text-to-Pay</div>
                                        <div className="payment-option-parag pb-2">
                                            Enroll in Text-to-Pay by
                                            logging into <a href={`https://${getRedirectEnv()}`}>My Account</a>.
                                            Once enrolled, you can pay
                                            by text using your checking,
                                            savings, credit or debit card.
                                            A convenience fee of $5.99
                                            applies.*
                                        </div>
                                    </div>
                                </div>
                                <hr style={{ background: "gray", margin: "5px" }} />
                                {/* <%-- Pay By Phone Automated --%> */}
                                <div className="payment-option px-1 py-2">
                                    <div className="col-3 pl-0 pt-1">
                                        <img src={Images.portalOne.nouns.phonePayment} width="70" height="90" />
                                    </div>
                                    <div className="col-9 pl-1" style={{ fontSize: "14px" }}>
                                        <div className="payment-option-title pb-2">Pay By Phone Automated</div>
                                        <div className="payment-option-parag pb-2">
                                            Use the automated interactive
                                            phone system 24/7 with your
                                            checking, savings, credit or
                                            debit card. A convenience fee
                                            of $14.95 applies.*
                                        </div>
                                        <div className="payment-option-parag pb-2">
                                            <a href="tel:8334812486" style={{ color: "#000000" }}>833-481-2486</a>
                                        </div>
                                    </div>
                                </div>
                                <hr style={{ background: "gray", margin: "5px" }} />
                                {/* <%-- Pay By Phone Live Agent --%> */}
                                <div className="payment-option px-1 py-2">
                                    <div className="col-3 pl-0 pt-1">
                                        <img src={Images.portalOne.nouns.telemarketing} width="74" height="66" />
                                    </div>
                                    <div className="col-9 pl-1" style={{ fontSize: "14px" }}>
                                        <div className="payment-option-title pb-2">Pay By Phone Live Agent</div>
                                        <div className="payment-option-parag pb-2">
                                            Contact a live agent with your checking, savings, credit or debit card.
                                            A convenience fee of $17.95 applies.*
                                        </div>
                                        <div className="payment-option-parag pb-2">
                                            <a href="tel:8005352873" style={{ color: "#000000" }} >800-535-2873</a>
                                        </div>
                                        <div className="payment-option-parag pb-2">
                                            Mon-Fri 8:00 am – 7:00 pm <br />
                                            Sat 9:30 am – 4:00 pm
                                        </div>
                                    </div>
                                </div>
                                <hr style={{ background: "gray", margin: "5px" }} />
                                {/* <%-- Pay By Mail --%> */}
                                <div className="payment-option px-1 py-2">
                                    <div className="col-3 pl-0 pt-1">
                                        <img src={Images.portalOne.nouns.envelope} width="70" height="70" />
                                    </div>
                                    <div className="col-9 pl-1" style={{ fontSize: "14px" }}>
                                        <div className="payment-option-title pb-2">Pay By Mail</div>
                                        <div className="payment-option-parag pb-2">
                                            Send a check or money order
                                            and be sure to include your
                                            Policy Number.
                                        </div>
                                        <div className="payment-option-parag pb-2">
                                            CURE <br />
                                            PO Box 48285 <br />
                                            Newark, NJ 07101-8485
                                        </div>
                                        <div className="payment-option-parag pb-2">
                                            Note: We recommend 5-7
                                            business days for mail and
                                            processing time.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* <%-- Footer --%> */}
                        <div className="modal-footer pt-0" style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                            <p style={{ textAlign:'center', color: "black", fontFamily: "Arial", fontSize: "13px" }}>*The third party convenience fee, charged by One Inc, will be added to your payment. 
                            For more information about One Inc, visit <a href='https://www.oneinc.com/' target='_blank'>oneinc.com</a>.</p>
                            <button onClick={() => setShow(false)} type="button" className="btn btn-secondary" data-dismiss="modal" style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", color: "white", backgroundImage: "none" }}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    )
}

export default OtherOptions